/**
 * Created by milky on 2018/10/22.
 */
var parse = {
  divideList (list, getList, number) {
    var productList = []
    if (number >= 0) {
      if (list[0] !== 0) {
        for (var i = 0; i < list.length; i++) {
          // price = price + this.changeToAdjustList(adjusts[j])[4]
          productList.push(getList(list[i])[number])
        }
        return productList
      } else {
        return 0
      }
    } else {
      if (list[0] !== 0) {
        for (var j = 0; j < list.length; j++) {
          // price = price + this.changeToAdjustList(adjusts[j])[4]
          productList.push(getList(list[j]))
        }
        return productList
      } else {
        return 0
      }
    }
  },
  getCommons (commonList) {
    var combineCount = 1
    var screen = []
    var carry = []
    var result = []
    for (var m = commonList.length - 1; m >= 0; m--) {
      combineCount = combineCount * commonList[m].length
      carry.push(combineCount)
      screen.push(0)
    }
    for (var i = 0; i < combineCount; i++) {
      var isCarry = false
      for (var j = commonList.length - 1; j >= 0; j--) {
        if (i >= carry[j] && i % carry[j] === 0) {
          for (var k = j; k >= 0; k--) {
            screen[k] = 0
          }
          screen[j + 1]++
          isCarry = true
          break
        }
      }
      if (i > 0 && !isCarry) {
        screen[0]++
      }
      var fullName = []
      for (var si = screen.length - 1; si >= 0; si--) {
        var sir = (si - screen.length + 1) * -1
        // fullName = fullName + commonList[sir][screen[si]][0] + ':' + commonList[sir][screen[si]][2]
        // fullName += (commonList[sir][screen[si]][0] + ':' + commonList[sir][screen[si]][2] + '/')
        fullName.push(commonList[sir][screen[si]])
        // fullName += commonList[sir][screen[si]][2]
      }
      result.push(fullName)
    }
    return result
  }
}
export default parse



// WEBPACK FOOTER //
// ./src/assets/js/parse-menu.js